import { useUser } from "@/context/useUser";
import { getAccessToken } from "@/lib/storeManager";
import { Navigate, Outlet } from "react-router-dom";
import screenerNavigationRoutes from "../../utils/navigationRoutes";

const ScreenerProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;

  return isAuthenticated || isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to={screenerNavigationRoutes.SCREENER_HOME} />
  );
};

export default ScreenerProtectedRouter;
